import React, { Component } from 'react';
import {observer} from 'mobx-react';
import orgstore from '../store/org-store';
import { Button, List, Form, Input, Checkbox } from 'semantic-ui-react';
import eb from '../utils/EventBus';
import { withRouter } from 'react-router-dom'


class OrgUpdate extends Component {

   componentDidMount() {
                const { match } = this.props;
                orgstore.loadOrg(match.params.id);
                eb.on('org-updated', () => this.props.history.push('/org'));
        }

	

  render() {
		const org = orgstore.selectedOrg;

    return (
       <div className="buyer-invoice">
                <div className="title">
					<h4 align="left">Update Organization</h4>
				</div>
				{org && (
				<Form>
				       <Form.Field inline>
					         <label>Organization Name</label>
                             <Input className="w-100" value={org.orgname} onChange={(evt, {value})=> orgstore.setOrgName(value)}/>
				       </Form.Field>

				       <Form.Field inline>
					         <label>Legal Name</label>
                             <Input className="w-100" value={org.legalname} onChange={(evt, {value})=> orgstore.setLegalName(value)}/>
				       </Form.Field>

				       <Form.Field inline>
					         <label>Business Type</label>
                             <Input  className="w-100" value={org.businesstype} onChange={(evt, {value})=> orgstore.setBusinessType(value)}/>
				       </Form.Field>

				       <Form.Field inline>
					         <label>Organization Role Type</label>
                             <Input className="w-100" value={org.orgroletype} onChange={(evt, {value})=> orgstore.setOrgRoleType(value)}/>
				       </Form.Field>

				       <Form.Field inline>
					         <label>Credit Rating</label>
                             <Input className="w-100" value={org.creditrating} onChange={(evt, {value})=> orgstore.setCreditRating(value)}/>
				       </Form.Field>

				       <Form.Field inline>
					         <label>Organization Number</label>
                             <Input className="w-100" value={org.organizationnumber} onChange={(evt, {value})=> orgstore.setOrganizationNumber(value)}/>
				       </Form.Field>

				       <Form.Field inline>
					         <label>Number of Employees</label>
                             <Input className="w-100" value={org.numberofemployees} onChange={(evt, {value})=> orgstore.setNumberOfEmployees(value)}/>
				       </Form.Field>

				       <Form.Field inline>
					         <label>DUNS Number</label>
                             <Input className="w-100" value={org.dunsnumber} onChange={(evt, {value})=> orgstore.setDunsNumber(value)}/>
				       </Form.Field>

				       <Form.Field inline>
					         <label>Year Established</label>
                             <Input className="w-100" value={org.yearestablished} onChange={(evt, {value})=> orgstore.setYearEstablished(value)}/>
				       </Form.Field>

				      <Form.Field inline>
							<label>Active Flag</label>
							<Input className="w-100" value={org.activeflag || ''} onChange={(evt, { value }) => orgstore.setActiveFlag(value)} />
						</Form.Field>

							<Button className="save" primary onClick={orgstore.updOrg}>Save</Button>
				</Form>
				)}
	             <div className="footer">
	        
	             </div>
		  </div>
    );
  }
}

export default withRouter(observer(OrgUpdate));



// WEBPACK FOOTER //
// ./src/containers/OrgUpdate.js